import { useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import VideoBrowser from "@/components/feature/VideoBrowser";
import NotFound from "@/pages/NotFound";
import { categoryMeta, type VideoType } from "@/mocks/videos";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const VALID: VideoType[] = ["movie", "tv", "short"];

export default function VideoList() {
  const { type } = useParams<{ type: string }>();
  const valid = VALID.includes(type as VideoType);
  const videoType = (valid ? type : "movie") as VideoType;
  const meta = categoryMeta[videoType];

  useDocumentMeta({
    title: valid ? `${meta.label}频道列表-69视频-丰富的视频资源平台` : "69视频-视频列表",
    description: valid
      ? `69视频${meta.label}频道列表页，支持按地区、年份、题材与标签细化筛选，快速找到你感兴趣的作品。`
      : "69视频视频列表页。",
    keywords: valid ? `${meta.label}列表,${meta.label}筛选,69视频,在线视频` : "69视频,视频列表",
    canonicalPath: valid ? `/category/${videoType}/list` : "/",
  });

  if (!valid) return <NotFound />;

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-8 pt-8 pb-6 bg-background-100 border-b border-background-200/70">
        <Breadcrumb
          items={[
            { label: "首页", path: "/" },
            { label: meta.label, path: `/category/${videoType}` },
            { label: "全部列表" },
          ]}
        />
        <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mt-5">
          {meta.label} · 全部列表
        </h1>
        <p className="text-sm text-foreground-600 mt-2 max-w-3xl leading-relaxed">
          支持更细化的标签筛选与排序，适合在{meta.label}内容较多时逐层缩小范围，精准定位想看的内容。
        </p>
      </section>

      <VideoBrowser type={videoType} variant="list" />
    </div>
  );
}